import { storageService } from '@/services'
import { isNan, isNullOrUndefined, isNumber, isString } from '@/util/validators/baseComponentsValidators'

export const coinsToGrn = (coins) => coins / 100
const addSpaces = (rawVal) => rawVal
  .toString()
  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

/** Метод для форматирования сумм */
const formatCustomSum = (sum) => {
  if (sum > 999.99) {
    const arr = Math.trunc(sum)
      .toString()
      .split('')
    arr.splice(-3, 0, ' ')
    if (sum > 999999.99) {
      arr.splice(-7, 0, ' ')
    }
    return arr.join('')
  }
  return sum.toFixed(2)
}
/** Универсальная функция для форматирования числе */
export const formatNumberFilter = (
  value,
  {
    format = 'grn',  //  формат: 'num', 'grn', 'balance', 'per', 'customSum'
    grnSign = true,  // показывать ли знак гривны
    isShowSymbol = true,  // показывать ли символ процента для процентов
    addCoins= false,
  } = {}
) => {
  if (isNullOrUndefined(value)) return ''

  let numberValue = Number(value)
  if (isNan(numberValue)) return value

  switch (format) {
  case 'grn':
    numberValue = Math.floor(numberValue)
    numberValue = coinsToGrn(numberValue)
    if (+numberValue < 100 && addCoins) {
      return `${((+numberValue * 100 )/ 100).toFixed(2)}${grnSign ? ' ₴' : ''}`
    }
    if (numberValue >= 100 && addCoins) numberValue = Math.floor(numberValue)
    if (numberValue >= 1000) numberValue = Math.floor(numberValue)
    const spacedString = addSpaces(numberValue)
    return `${spacedString}${grnSign ? ' ₴' : ''}`

  case 'balance':
    let res = ''
    if (numberValue >= 1000) {
      const string = numberValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      res = string.indexOf('.') !== -1 ? string.substr(0, string.indexOf('.')) : string
    }
    else {
      res = String(numberValue)
    }
    return `${res} ₴`

  case 'per':
    return `${(numberValue / 100)}${isShowSymbol ? '%' : ''}`

  case 'customSum':
    return formatCustomSum(numberValue)

  case 'comission':
    return `${formatCustomSum(numberValue / 100)}${grnSign ? ' ₴`' : ''}`

  case 'currency':
    return formatCurrency(numberValue)

  case 'num':
  default:
    return new Intl.NumberFormat('ru-RU').format(numberValue)
  }
}
/** Date */
export const dateDot = (value) => {
  if (!value) return ''
  const val = value.toString()
  const pattern = /^(\d{4})-(\d{2})-(\d{2})$/
  return val.split(' ')[0].replace(pattern, (match, year, month, day) => `${day}.${month}.${year}`)
  // '2023-10-14 16:18:00' --> '14.10.2023'
}

export const ho = (number) => {
  if (!isNumber(number) && !isString(number)) return number
  const lang = storageService.getItem('i18n_redirected')
  return `${number} ${lang === 'ru' ? 'ч' : 'год'}`
}
export const day = (number) => {
  if (!isNumber(number) && !isString(number)) return number
  const lang = storageService.getItem('i18n_redirected')
  return `${number} ${lang === 'ru' ? 'д' : 'д'}`
}

function formatCurrency(amountInCents) {
  const amountInHryvnia = amountInCents

  // Форматируем число с максимум 2 знаками после запятой
  const formattedAmount = amountInHryvnia.toFixed(2)

  // Разбиваем целую часть на группы по 3 символа
  const parts = formattedAmount.split('.')
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  // Если сумма меньше 100 грн, добавляем копейки
  if (amountInHryvnia < 100) {
    return `${integerPart}.${parts[1]}`
  }
  else {
    return integerPart
  }
}
